import isArray from "./is-array";

export default function isObject(o) {
  return o === Object(o) && !isArray(o) && typeof o !== "function";
}
